import { Asset } from 'cc';

export default class AssetCache {
    private _assetCache: Map<typeof Asset, Record<string, Asset>> = new Map();

    public set<T extends typeof Asset>(type: T, key: string, asset: InstanceType<T>) {
        if (!this._assetCache.has(type)) {
            this._assetCache.set(type, {});
        }
        const assetMap = this._assetCache.get(type);
        assetMap[key] = asset;
    }

    public clear<T extends typeof Asset>(type: T, key: string) {
        if (!this._assetCache.has(type)) {
            this._assetCache.set(type, {});
        }
        const assetMap = this._assetCache.get(type);
        assetMap[key] = null;
    }

    public get<T extends typeof Asset>(type: T, key: string): InstanceType<T> {
        if (!this._assetCache.has(type)) {
            this._assetCache.set(type, {});
        }
        return this._getValidAsset(type, key) as InstanceType<T>;
    }

    public getAll<T extends typeof Asset>(type: T): Record<string, InstanceType<T>> {
        if (!this._assetCache.has(type)) {
            this._assetCache.set(type, {});
        }
        return this._getAllValidAssets(type) as Record<string, InstanceType<T>>;
    }

    private _getAllValidAssets(type: typeof Asset): Record<string, Asset> {
        const assetMap = this._assetCache.get(type);
        Object.entries(assetMap).forEach(([k, v]) => {
            if (v && !v.isValid) {
                assetMap[k] = null;
            }
        });
        return assetMap;
    }

    private _getValidAsset(type: typeof Asset, key: string): Asset {
        const assetMap = this._assetCache.get(type);
        const asset = assetMap[key];
        if (asset && !asset.isValid) {
            assetMap[key] = null;
        }
        return assetMap[key];
    }
}
